import { Widget } from "../components/Widget";
import { UIEvent } from "./UIEvent";
import { Sprite } from "../display/Sprite";
import { Event } from "../events/Event";
import { ILaya } from "../../ILaya";
import { SerializeUtil } from "../loaders/SerializeUtil";
import { GrayscaleEffect2D } from "../display/effect2d/ColorEffect2D";
import { TransformKind } from "../display/SpriteConst";
import { LayaEnv } from "../../LayaEnv";
export class UIComponent extends Sprite {
    get top() {
        return this.get_top();
    }
    set top(value) {
        this.set_top(value);
    }
    get bottom() {
        return this.get_bottom();
    }
    set bottom(value) {
        this.set_bottom(value);
    }
    get left() {
        return this._widget.left;
    }
    set left(value) {
        if (value != this._widget.left) {
            this._getWidget().left = value;
        }
    }
    get right() {
        return this._widget.right;
    }
    set right(value) {
        if (value != this._widget.right) {
            this._getWidget().right = value;
        }
    }
    get centerX() {
        return this._widget.centerX;
    }
    set centerX(value) {
        if (value != this._widget.centerX) {
            this._getWidget().centerX = value;
        }
    }
    get centerY() {
        return this._widget.centerY;
    }
    set centerY(value) {
        if (value != this._widget.centerY) {
            this._getWidget().centerY = value;
        }
    }
    get dataSource() {
        return this.get_dataSource();
    }
    set dataSource(value) {
        this.set_dataSource(value);
    }
    get toolTip() {
        return this._toolTip;
    }
    set toolTip(value) {
        if (this._toolTip != value) {
            this._toolTip = value;
            if (value != null) {
                this.on(Event.MOUSE_OVER, this, this.onMouseOver);
                this.on(Event.MOUSE_OUT, this, this.onMouseOut);
            }
            else {
                this.off(Event.MOUSE_OVER, this, this.onMouseOver);
                this.off(Event.MOUSE_OUT, this, this.onMouseOut);
            }
        }
    }
    get gray() {
        return this._gray;
    }
    set gray(value) {
        value = !!value;
        if (value !== this._gray) {
            this._gray = value;
            let postProcess = this.getPostProcess(value);
            if (value) {
                let effect = postProcess.getEffect(GrayscaleEffect2D);
                if (!effect)
                    effect = postProcess.addEffect(new GrayscaleEffect2D());
            }
            else {
                if (postProcess) {
                    let effect = postProcess.getEffect(GrayscaleEffect2D);
                    if (effect) {
                        postProcess.removeEffect(effect);
                        if (!LayaEnv.isPlaying && postProcess.effects.length === 0)
                            this.postProcess = null;
                    }
                }
            }
        }
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        if (value !== this._disabled) {
            this._disabled = value;
            if (!SerializeUtil.isDeserializing)
                this.gray = value;
            this.mouseEnabled = !value;
        }
    }
    constructor(createChildren = true) {
        super();
        this._widget = Widget.EMPTY;
        if (createChildren) {
            this.preinitialize();
            this.createChildren();
            this.initialize();
        }
    }
    _transChanged(kind) {
        super._transChanged(kind);
        if ((kind & TransformKind.Layout) != 0)
            this.callLater(this._sizeChanged);
    }
    _sizeChanged() {
        this.event(Event.RESIZE);
        if (this._widget !== Widget.EMPTY)
            this._widget.resetLayout();
    }
    _childChanged(child) {
        this.callLater(this._sizeChanged);
        super._childChanged(child);
    }
    _getWidget() {
        this._widget === Widget.EMPTY && (this._widget = this.addComponent(Widget));
        return this._widget;
    }
    preinitialize() {
    }
    createChildren() {
    }
    initialize() {
    }
    measureWidth() {
        var max = 0;
        this.commitMeasure();
        for (var i = this.numChildren - 1; i > -1; i--) {
            var comp = this.getChildAt(i);
            if (comp._visible) {
                max = Math.max(comp._x + comp.width * comp.scaleX, max);
            }
        }
        return max;
    }
    commitMeasure() {
    }
    measureHeight() {
        let max = 0;
        this.commitMeasure();
        for (let i = this.numChildren - 1; i > -1; i--) {
            let comp = this.getChildAt(i);
            if (comp._visible) {
                max = Math.max(comp._y + comp.height * comp.scaleY, max);
            }
        }
        return max;
    }
    onMouseOver(e) {
        ILaya.stage.event(UIEvent.SHOW_TIP, this._toolTip);
    }
    onMouseOut(e) {
        ILaya.stage.event(UIEvent.HIDE_TIP, this._toolTip);
    }
    get_top() {
        return this._widget.top;
    }
    set_top(value) {
        if (value != this._widget.top) {
            this._getWidget().top = value;
        }
    }
    get_bottom() {
        return this._widget.bottom;
    }
    set_bottom(value) {
        if (value != this._widget.bottom) {
            this._getWidget().bottom = value;
        }
    }
    get_dataSource() {
        return this._dataSource;
    }
    set_dataSource(value) {
        this._dataSource = value;
        for (var prop in this._dataSource) {
            if (prop in this && !(typeof (this[prop]) == 'function')) {
                this[prop] = this._dataSource[prop];
            }
        }
    }
    freshLayout() {
        if (this._widget != Widget.EMPTY) {
            this._widget.resetLayout();
        }
    }
    destroy(destroyChild = true) {
        super.destroy(destroyChild);
        this._dataSource = null;
        this._toolTip = null;
    }
}
